import MicroModal from 'micromodal';
import { readCookie, createCookie } from 'Utilities/cookies';

const cookieName = 'hide-signup';
const days = 30;
let showModal = readCookie(cookieName) != 'hidden';

// if (showModal) {
//     if (showModal) {
//         setTimeout(function() {
//             MicroModal.show('modal--popup', {
//                 onClose: modal => {
//                     createCookie(cookieName, 'hidden', days);
//                     showModal = false;
//                 },
//                 disableScroll: true,
//                 disableFocus: false,
//                 awaitCloseAnimation: false,
//                 debugMode: false
//             });
//         }, 5000);
//     }
// }

const modalClose = document.querySelector('.modal--close');
if (modalClose) {
    modalClose.addEventListener('click', function(e) {
        e.preventDefault();
        MicroModal.close('modal--popup');
        createCookie(cookieName, 'hidden', days);
    });
}

const forms = document.querySelectorAll('.newsletter-popup-form');
for (var i = 0, len = forms.length; i < len; i++) {
    const form = forms[i];
    form.addEventListener('submit', function(e) {
        createCookie(cookieName, 'hidden', days);
        showModal = false;
    });
}
